import { render, staticRenderFns } from "./CreatedOrUpdate.vue?vue&type=template&id=faf177ca"
import script from "./CreatedOrUpdate.vue?vue&type=script&lang=js"
export * from "./CreatedOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports